<script setup lang="ts">
  import { MpDivider, MpText } from '@borg/ui';

  const organizationCard = useOrganizationCard.inject();

  const key = ref(1);

  const badges = computed(() => {
    if (
      organizationCard.organization &&
      organizationCard.organization !== 'incognito' &&
      !!organizationCard.organization.badges
    ) {
      return organizationCard.organization.badges;
    }
    return [];
  });

  onMounted(() => {
    key.value += 1;
  });
</script>

<template>
  <div
    v-if="badges.length"
    class="badges"
  >
    <div class="badges__header">
      <MpDivider margin="sm" />
      <MpText
        as="h6"
        no-margin
        style="align-self: flex-start"
      >
        {{ $t('ORGANIZATION_CARD.BADGES_TITLE') }}
      </MpText>
    </div>
    <div class="badges__list">
      <div
        v-for="(badge, i) in badges"
        :key="i"
        class="badges__badge"
      >
        <img
          loading="lazy"
          :src="badge.image"
          class="badges__badge-image"
          alt="badge"
        />
        <MpText
          :key="`post-ssr-fix-${i}-${key}`"
          class="badges__badge-content"
          type="body2"
          no-margin
          v-html="badge.content"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .badges {
    width: 100%;

    &__header {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--mp-space-50);
      margin-bottom: var(--mp-space-50);
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: var(--mp-space-70);
      width: 100%;
    }

    &__badge-content {
      :deep(a) {
        font-weight: var(--mp-font-weight-semibold);
        text-decoration: underline;
      }
    }

    &__badge {
      display: flex;
      gap: var(--mp-space-50);
      align-items: center;
    }

    &__badge-image {
      max-width: 64px;
      max-height: 64px;
    }
  }
</style>
